import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  hasPrintsSelected,
  getSelectedCategoryFacet,
  getSelectedFacetsCount,
} from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  facetCount: getSelectedFacetsCount,
  hasPrints: hasPrintsSelected,
  selectedCategoryFacet: getSelectedCategoryFacet,
})

export type ConnectorProps = {
  facetCount: number
  hasPrints: boolean
  selectedCategoryFacet: string
}

export default connect(mapStateToProps)
